import { AbstractUser} from '../types/auth.types';
import { UserRole } from '../types/user.types';


export const isAdmin = (user: Partial<AbstractUser>) => {
  return user && user?.roles?.includes(UserRole.ROLE_ADMIN);
};
